import {FormProvider} from '@yandex-delivery/form'
import React from 'react'
import {Helmet} from 'react-helmet-async'

import {Footer, Header} from 'src/entities/desktop'
import {appConfig, i18n} from 'src/shared/config'
import {ExistingOrderDetector} from 'src/widgets/desktop'

import {OrderForm} from '../OrderForm/OrderForm'
import {OrderMap} from '../OrderMap/OrderMap'
import * as classes from './HomePage.classes'
import {useDefaultFormValues} from './HomePage.hooks'
import {FormSchema} from './schema'

export function HomePage(): React.ReactElement {
  const defaultFormValues = useDefaultFormValues()

  return (
    <>
      <Helmet>
        <title>{i18n('order.main-page.title')}</title>
        <link href={`${appConfig.origin}/order/`} rel="canonical" />
      </Helmet>
      <Header />
      <main className={classes.content}>
        <FormProvider
          defaultValues={defaultFormValues}
          // @ts-expect-error что-то с типизацией
          validationSchema={FormSchema}
          debug
        >
          <div className={classes.root}>
            <div className={classes.formWrapper}>
              <div className={classes.form} data-e2e="full-form">
                <ExistingOrderDetector />
                <OrderForm />
              </div>
            </div>
            <div className={classes.map}>
              <OrderMap location={appConfig.location} />
            </div>
            {/*<div className={classes.banners}>
              <Banners />
            </div>*/}
          </div>
        </FormProvider>
      </main>
      <Footer />
    </>
  )
}
